import { makeAutoObservable } from 'mobx';
import { ViewManager } from './ViewManager';
import { ClosetManager } from './ClosetManager';
import { OperationsManager } from './OperationsManager';
import { DrawingManager } from './DrawingManager';
import { ApiManager } from './ApiManager';
import { MatrixManager } from './MatrixManager';
import { UiManager } from './UiManager';

export class StateManager {
    constructor() {
        makeAutoObservable(this);
    }

    _viewManager = new ViewManager(this);

    get viewManager() {
        return this._viewManager;
    }

    _closetManager = new ClosetManager(this);

    get closetManager() {
        return this._closetManager;
    }

    _drawingManager = new DrawingManager(this);

    get drawingManager() {
        return this._drawingManager;
    }

    _apiManager = new ApiManager(this);

    get apiManager() {
        return this._apiManager;
    }

    _operationsManager = new OperationsManager(this);

    get operationsManager() {
        return this._operationsManager;
    }

    _matrixManager = new MatrixManager(this);

    get matrixManager() {
        return this._matrixManager;
    }
    _uiManager = new UiManager(this);

    get uiManager() {
        return this._uiManager;
    }
}
